import { useStoreCart } from "~/pages/cart/StoreCart/useStoreCart";

import { Text } from "../Text";
import { showToast } from "~/utils/toast";
import UncontrolledInput from "../Backroom/UncontrolledInput";
import { getAddressComponents } from "../Backroom/AddressInput/googleMapsHelpers";
import { UncontrolledAddressInput } from "../Backroom/UncontrolledAddressInput";

export type CartAddress = {
  zipcode?: string;
  address?: string;
  address2?: string;
  city?: string;
};

type Props = {
  className?: string;
};

export const CartAddressInput = ({ className }: Props) => {
  const { setSavedValues } = useStoreCart();

  const onSelectPlace = (place: google.maps.places.PlaceResult | null) => {
    if (!place) return;

    const components = getAddressComponents(place);
    if (!components?.address || !components?.city || !components?.postCode) {
      showToast("danger", "Vælg venligst en præcis adresse.");
      return;
    }

    const { address, address2, city, postCode } = components;

    setSavedValues((prev) => ({
      ...prev,
      receiverAddress: { postCode, city, line1: address, line2: address2 },
    }));
  };

  const onChangeName = async (name: string) => {
    setSavedValues((prev) => ({ ...prev, receiverName: name }));
  };

  return (
    <div className={className}>
      <Text>Indtast leveringsadresse</Text>
      <UncontrolledInput
        className="mt-4"
        id="receiverName"
        label="Modtagers navn"
        placeholder="Jane Hansen"
        onChange={(e) => onChangeName(e.target.value)}
      />
      <UncontrolledAddressInput
        className="mt-4"
        id="addressField"
        onSelectPlace={onSelectPlace}
        label="Adresse"
        placeholder="Storegade 12, 8900 Randers"
        suggestionsClassName="bg-secondary-200"
      />
    </div>
  );
};
